var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"utility-flex-center",style:({
		height: ((parseInt(_vm.props.verticalSpace) +
			parseInt(_vm.props.height)) + "px"),
	})},[_c('div',{staticClass:"loading-indicator bg-color-surface-alt margin-l-auto margin-r-auto position-relative",style:({
			width: ((parseInt(_vm.props.width)) + "px"),
			height: ((parseInt(_vm.props.height)) + "px"),
		})},[_c('div',{staticClass:"position-absolute bg-color-primary"})])])}
var staticRenderFns = []

export { render, staticRenderFns }